'use client';

import { forwardRef } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { filterChipWithMenuIconStyles } from './styles/filter-chip-with-menu-icon.styles';
import type { FilterChipWithMenuIconPropsInterface } from './types/filter-chip-with-menu-icon.types';

/**
 * @since 10.0.0
 */
export const FilterChipWithMenuIcon = forwardRef<
  SVGSVGElement,
  FilterChipWithMenuIconPropsInterface
>((props, forwardedRef) => {
  const { children, css: cssProp, ...rest } = props;

  return (
    <Icon
      data-c11n-component="FilterChipWithMenu.Icon"
      data-c11n-version={__C11N_VERSION__}
      ref={forwardedRef}
      css={{ ...filterChipWithMenuIconStyles, ...cssProp }}
      {...rest}
      className={cx('c11n_filter-chip-with-menu__icon', rest.className)}
    >
      {children}
    </Icon>
  );
});

FilterChipWithMenuIcon.displayName = 'FilterChipWithMenu.Icon';
